<template>
  <div class="content-wrap">
    <div class="main">
      <div class="container-fluid">
        <div class="row">
          <div class="col-lg-6" v-for="dep in mainDepAry" :key="dep.dep">
            <div class="card">
              <div class="card-title">{{dep.depName}}</div>
              <div class="card-body">
                <table class="table table-hover">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>編號</th>
                      <th>姓名</th>
                      <th>管理</th>
                      <th>switch</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(data,index) in renderData[dep.dep]" :key="index">
                      <td>{{index+1}}</td>
                      <td>{{data.gh_id}}</td>
                      <td>{{data.name}}</td>
                      <td>
                        <input
                          type="checkbox"
                          v-model="data.auth"
                          :true-value="1"
                          :false-value="0"
                          @click="changeAuthHandler(data.gh_id)"
                        />
                      </td>
                      <td>
                        <input
                          type="checkbox"
                          v-model="data.switch"
                          :true-value="1"
                          :false-value="0"
                          @click="changeSwitchHandler(data.gh_id)"
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      mainData: []
    };
  },
  props: {
    depAry: {
      type: Array,
      required: true
    }
  },
  created() {
    $.ajax({
      url: './php/main.php',
      type: 'post',
      data: { function: 'admin_getData' }
    }).done(res => {
      const data = JSON.parse(res);
      this.mainData = data;
    });
  },
  computed: {
    mainDepAry() {
      let ary = this.depAry.reduce((prev, next) => {
        prev.push({
          dep: next,
          depName:
            next === 'poster'
              ? '海報'
              : next === 'card'
              ? '名片'
              : next === 'ink'
              ? '大圖'
              : '數位印刷'
        });
        return prev;
      }, []);
      ary.push({ dep: 'all', depName: '其他' });
      return ary;
    },
    renderData() {
      if (this.mainData.length === 0) return [];
      return this.mainData.reduce((prev, next) => {
        if (!prev.hasOwnProperty(next.department)) {
          prev[next.department] = [];
        }
        prev[next.department].push({
          auth: next.auth,
          gh_id: next.gh_id,
          name: next.name,
          switch: next.switch
        });
        return prev;
      }, {});
    }
  },
  methods: {
    changeAuthHandler(id) {
      this.mainData.forEach(el => {
        if (el.gh_id === id) {
          el.auth = !el.auth;
          let flag = el.auth == true ? 1 : 0;
          this.setDataHandler('auth', flag, id);
        }
      });
    },
    changeSwitchHandler(id) {
      this.mainData.forEach(el => {
        if (el.gh_id === id) {
          el.switch = !el.switch;          
          let flag = el.switch == true ? 1 : 0;
          this.setDataHandler('switch', flag, id);
        }
      });
    },
    setDataHandler(str, flag, id) {
      $.ajax({
        url: './php/main.php',
        type: 'post',
        data: { function: 'admin_setDataHandler', str: str, flag: flag, id: id }
      });
    }
  }
};
</script>